// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean, number } from "@altostra/type-validations/lib/primitives";

export const isPostEngagementConversionReportResult = objectOf({
  _id: string,
  ag_id: string,
  c_at: string,
  c_id: string,
  cet: string,
  cf: arrayOf(string),
  ch: arrayOf(string),
  cryf: arrayOf(string),
  cvf: arrayOf(string),
  cvsf: arrayOf(string),
  d_id: string,
  iue: boolean,
  qt: string,
  rdr: arrayOf(string),
  rptk: string,
  tc: number,
  tf: arrayOf(string),
  u_at: string,
  conversion_event: string,
  conversion_event_type: string,
  conversion_window: number,
  query_type: string,
  channels: arrayOf(string),
  include_untracked_events: boolean,
  campaign_filter: arrayOf(string),
  canvas_step_filter: arrayOf(string),
  canvas_filter: arrayOf(string),
  country_filter: arrayOf(string),
  tag_filter: arrayOf(string),
  date_range: arrayOf(string),
  results_generated: string,
  results: arrayOf(
    objectOf({
      total_conversions: string,
      total_email_deliveries: string,
      total_email_opens: string,
      total_email_clicks: string,
      total_email_delivery_conversions: string,
      total_email_open_conversions: string,
      total_email_click_conversions: string,
      total_unique_conversions: string,
      total_unique_email_deliveries: string,
      total_unique_email_opens: string,
      total_unique_email_clicks: string,
      total_unique_email_delivery_conversions: string,
      total_unique_email_open_conversions: string,
      total_unique_email_click_conversions: string,
      total_last_click_conversions: string,
      total_unique_last_click_conversions: string,
    })
  ),
  loading: boolean,
  failure_count: number,
});
